import angular from 'angular';

const componentOptions = {
    bindings: {
        stepControl: '=',
        model: '='
    },
    controllerAs: 'headerStepsCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-header-steps-bids-view.html';
    }]
};


const componentInfo = {
    module: 'ib-header-steps-bids-module',
    selector: 'ibHeaderStepsBids',
    inject: ['$rootScope', 'localStorageService'],
    required: ['']
};


export class ibHeaderStepsBids implements ng.IController {
    constructor (private $rootScope: CommonsRootScope,
        private localStorageService: angular.local.storage.ILocalStorageService
    ) {
    }

    exitBidsFlow = (): void => {
        this.$rootScope.$broadcast('closeBidModal');
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        this.localStorageService.remove('upgradingBidsSlicesInfoResult');
    };
}

try {
    const mod = angular.module(componentInfo.module);
    ibHeaderStepsBids.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibHeaderStepsBids })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibHeaderStepsBids.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibHeaderStepsBids })
    );
}